export const getTranslations = () =>
  import.meta.glob('../../translations/*.json');
